import { createApp } from 'vue'
import App from './App.vue'
import { flash } from './flash'

// Font Awesome Imports
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTemperatureHalf } from '@fortawesome/free-solid-svg-icons'
import { faBolt } from '@fortawesome/free-solid-svg-icons'
import { faSun } from '@fortawesome/free-solid-svg-icons'
import { faWind } from '@fortawesome/free-solid-svg-icons'
import { faSmog } from '@fortawesome/free-solid-svg-icons'
import { faBatteryFull } from '@fortawesome/free-solid-svg-icons'
import { faBatteryEmpty } from '@fortawesome/free-solid-svg-icons'
import { faCloudRain } from '@fortawesome/free-solid-svg-icons'
import { faSignal } from '@fortawesome/free-solid-svg-icons'
import { faWifi } from '@fortawesome/free-solid-svg-icons'
import { faTowerBroadcast } from '@fortawesome/free-solid-svg-icons'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { faGaugeHigh } from '@fortawesome/free-solid-svg-icons'
import { faGauge } from '@fortawesome/free-solid-svg-icons'
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons'
import { faPlug } from '@fortawesome/free-solid-svg-icons'
import { faRadiation } from '@fortawesome/free-solid-svg-icons'

// Icon zur Bibliothek hinzufügen
library.add(faTemperatureHalf)
library.add(faBolt)
library.add(faSun)
library.add(faWind)
library.add(faSmog)
library.add(faBatteryFull)
library.add(faBatteryEmpty)
library.add(faCloudRain)
library.add(faSignal)
library.add(faWifi)
library.add(faTowerBroadcast)
library.add(faLightbulb)
library.add(faGaugeHigh)
library.add(faGauge)
library.add(faLocationArrow)
library.add(faPlug)
library.add(faRadiation)

const app = createApp(App)

// Globale Registrierung der FontAwesome-Komponente
app.component('font-awesome-icon', FontAwesomeIcon)

app.directive('flash', flash)

app.mount('#app')
